/**
 * Custom Drawer function for displaying custom content on an slide-out drawer.
 */
(function () {

    const drawer = document.querySelector('#custom-drawer'),
        triggers = document.querySelectorAll('.product__accordion'),
        closeButt = drawer.querySelector('#drawer-close');

    drawer.querySelector('#CartDrawer-Overlay').addEventListener('click', close.bind(this));
    closeButt.addEventListener('click', close.bind(this));

    triggers.forEach(function (button) {
        button.addEventListener('click', function (e) {
            e.preventDefault()

            var heading = drawer.querySelector('.drawer__heading'),
                container = drawer.querySelector('#drawer-contents');

            if (container) {
                heading.innerHTML = this.querySelector('.accordion__title').textContent;
                container.innerHTML = this.querySelector('.accordion__content').innerHTML;
                openSizes(container);
            }

            drawer.classList.add('active');
            document.body.classList.add('overflow-hidden');
        });
    });

    function close(e) {
        drawer.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
    }

    function openSizes(container) {

        var details = container.querySelector('details') !== null;
        if (details) {
            const sizes = ['clothing', 'footwear', 'gloves', 'rings'];
            sizes.forEach(function (size) {
                if (document.body.classList.contains(size)) {
                    container.querySelector(`details[name=${size}]`).open = true
                }
            });
        }
    }

})();